import { render, staticRenderFns } from "./addPropertyDialog.vue?vue&type=template&id=3392deac&scoped=true"
import script from "./addPropertyDialog.vue?vue&type=script&lang=js"
export * from "./addPropertyDialog.vue?vue&type=script&lang=js"
import style0 from "./addPropertyDialog.vue?vue&type=style&index=0&id=3392deac&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3392deac",
  null
  
)

export default component.exports